module.exports = __webpack_public_path__ + "img/bell-concierge.234fd884.svg";